import { render, staticRenderFns } from "./contextmenuexample.vue?vue&type=template&id=79e90a73&scoped=true&"
import script from "./contextmenuexample.vue?vue&type=script&lang=js&"
export * from "./contextmenuexample.vue?vue&type=script&lang=js&"
import style0 from "./contextmenuexample.vue?vue&type=style&index=0&id=79e90a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e90a73",
  null
  
)

export default component.exports